
/**
* src/connects/user-monthly-summary-page.js
*/

import { connect } from 'react-redux'
import lifecycle from '../helpers/lifecycle'
import combineHOC from '../helpers/combine-hoc'
import { validate } from '../helpers/form-validator'
import actions from '../actions'
import { translate } from 'react-i18next'
import moment from 'moment'
import config from '../config'
import ui from '../helpers/ui-state'

export const mapStateToProps = (state)=> {
  return {
    isPhone: state.media.isPhone,
    access_token: state.sessions.access_token,
  }
}

export default combineHOC(
  connect(mapStateToProps),
  ui({ state: { 
    date: moment(),
    edit: false,
  }}),
  lifecycle,
  translate(),
)



// WEBPACK FOOTER //
// ./src/connects/user-monthly-summary-page.js